// Mock data for Shalibhadra Chemicals

export const companyInfo = {
  name: "Shalibhadra Chemicals",
  tagline: "Excellence in Chemical Trading",
  email: "sales@shalibhadrachemicals.com",
  phone: "+91-9082501291 / 9867493031",
  address: "103 Vaibhav Horizon, Bhayander West, Thane - 401101, India",
  gstin: "27XXXXX1234X1ZX"
};

export const heroContent = {
  title: "Leading Chemical Supplier for Industrial Excellence",
  subtitle: "Premium quality chemicals for pharmaceutical, paints, inks, construction industries and many more",
  stats: [
    { value: "35+", label: "Products" },
    { value: "40+", label: "Happy Clients" },
    { value: "99.99%", label: "Purity Standards" }
  ]
};

export const aboutContent = {
  title: "About Shalibhadra Chemicals",
  description: "Shalibhadra Chemicals has emerged as a trusted name in the chemical trading industry. We specialize in providing high-quality chemicals to multiple sectors across India.",
  mission: "To deliver premium quality chemicals with unwavering commitment to safety, sustainability, and customer satisfaction.",
  vision: "To be the most trusted chemical supplier in India, known for quality, reliability, and innovation.",
  values: [
    "Quality Assurance",
    "Timely Delivery",
    "Customer Focus",
    "Safety Standards",
    "Ethical Practices"
  ]
};

export const whyChooseUs = [
  {
    title: "Premium Quality",
    description: "All chemicals undergo rigorous quality testing to meet industry standards and certifications.",
    icon: "shield-check"
  },
  {
    title: "Extensive Inventory",
    description: "Wide range of chemicals available for immediate delivery across various industrial applications.",
    icon: "warehouse"
  },
  {
    title: "Competitive Pricing",
    description: "Best market rates with flexible payment options and bulk order discounts.",
    icon: "badge-indian-rupee"
  },
  {
    title: "Timely Delivery",
    description: "Efficient logistics network ensuring on-time delivery across India.",
    icon: "truck"
  },
  {
    title: "Expert Support",
    description: "Technical expertise and customer support to help you choose the right chemicals.",
    icon: "headset"
  },
  {
    title: "Safety Compliant",
    description: "All products meet safety standards with proper handling and storage guidelines.",
    icon: "shield-alert"
  }
];

export const industries = [
  {
    title: "Pharmaceutical & Life Science",
    description: "High-purity chemicals for drug formulation, API manufacturing, and pharmaceutical research.",
    icon: "pill"
  },
  {
    title: "Paints, Coatings & Inks",
    description: "Solvents, resins, pigments and additives for decorative paints, industrial coatings and printing inks.",
    icon: "paint-bucket"
  },
  {
    title: "Construction & Building",
    description: "Cement additives, concrete admixtures, waterproofing chemicals and surface treatment solutions.",
    icon: "building-2"
  },
  {
    title: "Rubber & Polymer",
    description: "Processing aids, accelerators, antioxidants and specialty chemicals for rubber and polymer industries.",
    icon: "droplet"
  },
  {
    title: "Textile & Leather",
    description: "Dyes, auxiliaries, finishing agents and specialty chemicals for textile and leather processing.",
    icon: "shirt"
  },
  {
    title: "Adhesives & Sealants",
    description: "Raw materials and specialty chemicals for adhesive and sealant manufacturing.",
    icon: "layers"
  },
  {
    title: "Personal Care & Cosmetics",
    description: "Ingredients and active compounds for cosmetics, personal care and home care products.",
    icon: "sparkles"
  },
  {
    title: "Food & Beverage",
    description: "Food grade chemicals, preservatives, acidulants and processing aids for food industry.",
    icon: "utensils"
  }
];

export const allProducts = [
  "Acetone",
  "Acetonitrile",
  "Acetic Acid",
  "Butyl Alcohol",
  "Butyl Acetate",
  "Benzene",
  "Citric Acid",
  "Cyclohexane",
  "Cyclohexanone",
  "DETA",
  "Ethyl Acetate",
  "N-Heptane",
  "Isopropyl Alcohol",
  "Toluene",
  "Normal Butanol (NBA)",
  "Methyl Isobutyl Ketone (MIBK)",
  "Tetrahydrofuran (THF)",
  "2-Methyl THF",
  "N-Propanol",
  "Propyl Acetate",
  "Dimethyl Formamide (DMF)",
  "Dimethyl Sulfoxide",
  "Sucralose",
  "Ascorbic Acid",
  "Fumaric Acid",
  "Xanthan Gum",
  "Triethylamine (TEA)",
  "Acrylic Acid",
  "BAM",
  "VAM",
  "Adipic Acid",
  "Mono Sodium Phosphate",
  "Di Sodium Phosphate",
  "Tetra Sodium Pyro Phosphate",
  "Sodium Acetate"
];

export const testimonials = [
  {
    name: "Rajesh Kumar",
    company: "PharmaTech Industries",
    designation: "Procurement Manager",
    text: "Shalibhadra Chemicals has been our trusted partner for over 5 years. Their quality consistency and timely delivery have never disappointed us.",
    rating: 5
  },
  {
    name: "Priya Sharma",
    company: "ColorCraft Paints",
    designation: "Production Head",
    text: "Excellent quality chemicals at competitive prices. Their technical support team is very knowledgeable and responsive.",
    rating: 5
  },
  {
    name: "Amit Patel",
    company: "BuildPro Construction",
    designation: "Purchase Manager",
    text: "Reliable supplier with a wide range of products. Their delivery network ensures we never face material shortages.",
    rating: 5
  }
];